import Api from "./Api";

const endpoint = "/migration";
export default {
    contacts() {
        return Api.fetchData(endpoint + "/contacts");
    },
    images() {
        return Api.fetchData(endpoint + "/images");
    },
    probenplanTime() {
        return Api.fetchData(endpoint + "/probenplan/time");
    },
    bemerkung() {
        return Api.fetchData(endpoint + "/bemerkung");
    },
    mitgliedsbeitraege() {
        return Api.fetchData(endpoint + "/fibu_mitgliedsbeitraege_to_ops");
    },
    deleteMitgliedsbeitraegeMigration() {
        return Api.deleteData(endpoint + "/delete_fibu_mitgliedsbeitraege_to_ops");
    },
    migrateBuchungsstapel() {
        return Api.fetchData(endpoint + "/fibu_import_stapelbuchungen");
    },
    deleteBuchungsstapelMigration() {
        return Api.deleteData(endpoint + "/fibu_delete_stapelbuchungen_migration");
    },
    checkStapelbuchungRoute() {
        return Api.fetchData(endpoint + "/fibu_checkstapebuchungsroute_existenz");
    }
};
